import { gql } from "@apollo/client";

export const AssetDetail = gql`
    query AssetDetail (
        $filter: AssetFilterInput!
        $imageCrop:  ResizeCrop
        $imageWidth: Int
        $imageHeight: Int
    ) {
        asset (filter: $filter ) {
            id
            urn
            serialNumber
            product {
                id
                urn
                productCode
                name
                image {
                    id
                    thumbnailLink (crop: $imageCrop, w: $imageWidth, h: $imageHeight)
                }
            }
            manufacturer {
                id
                urn
                name
            }
        }
    }
`;
